import { useEffect, useRef } from 'react';
import useNotifStore from '../store/notifStore';

const WS_URL = process.env.REACT_APP_WS_URL || 'wss://terratrack-production.up.railway.app';

const useWebSocket = () => {
    const ws      = useRef(null);
    const addNotif = useNotifStore((s) => s.addNotif);

    useEffect(() => {
        const token = localStorage.getItem('access_token');
        if (!token) return;

        ws.current = new WebSocket(
            `${WS_URL}/ws/notifications/?token=${token}`
        );

        ws.current.onmessage = (e) => {
            const data = JSON.parse(e.data);
            if (data.type === 'notification') {
                addNotif(data);
            }
        };

        ws.current.onerror = (e) => console.error('WebSocket error:', e);

        return () => ws.current?.close();
    }, [addNotif]);

    return ws;
};

export default useWebSocket;